import React, { Component } from 'react';
import NowellonEditableFieldPropType from "../NowellonEditableField/NowellonEditableFieldPropType";
// import NowellonEditableField from "../NowellonEditableField";
import PropTypes from 'prop-types';

class BiographySection extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      getVal,
      biography
    } = this.props;
    return (
      <div className="expert-tab-content expert-biography" dangerouslySetInnerHTML={{ "__html": getVal(biography ) }}/>
    )
  }
}
BiographySection.propTypes = {
    getVal: PropTypes.func.isRequired,
    biography: NowellonEditableFieldPropType.isRequired
}
export default BiographySection;